import {Component, Input, OnInit, signal, WritableSignal} from '@angular/core';
import {ApiService} from '../../../../api/service/api.service';
import {Ticket} from '../../../../api/model/Ticket.model';
import {TicketLine} from '../../../../api/model/TicketLine.model';
import {ConfigService} from '../../../../core/services';

@Component({
  selector: 'tj-ticket-related',
  templateUrl: './related-tickets.component.html',
  styleUrls: ['./related-tickets.component.scss'],
})
export class RelatedTicketsComponent implements OnInit {
  @Input() ticket: Ticket;

  tickets: TicketLine[] = [];
  activeTab: WritableSignal<number> = signal(-1);
  isLoading = false;


  constructor(
    private api: ApiService,
    public configService: ConfigService,
  ) {}

  ngOnInit() {
    const counts = this.ticket.relatedTicketCounts;

    const firstActive = [
      {count: counts.customerNameCount, tabIndex: 0},
      {count: counts.addressCount, tabIndex: 1},
      {count: counts.customerContactsCount, tabIndex: 2},
      {count: counts.workOrderCount, tabIndex: 3},
    ].find(item => item.count > 0);

    if (firstActive) {
      const index = firstActive.tabIndex ?? 0;
      this.handleChange(index);
      this.activeTab.set(index);
    }

  }

  handleChange(index: number) {
    let relatedBy = '';
    switch (index) {
      case 0:
        relatedBy = 'customerName';
        break;
      case 1:
        relatedBy = 'address';
        break;
      case 2:
        relatedBy = 'customerContacts';
        break;
      case 3:
        if (this.ticket.externalReferenceCode) {
          relatedBy = 'workOrder';
        }
        break;
    }
    if (!relatedBy) {
      this.isLoading = false;
      return;
    }
    this.api.ticket.related(this.ticket.id, relatedBy).subscribe(value => {
      this.isLoading = false;
      return (this.tickets = value);
    });
  }

  onAccordionChange(index: number) {
    this.tickets = [];
    this.isLoading = true;
    this.handleChange(index);
  }
}
